import api from "./index";

export interface VideoListParams {
  ids?: Array<string>;
  title?: string;
  ownerId?: string;
  companyId?: string;
  categoryId?: string;
  viewerId?: string;
  priceMin?: number;
  priceMax?: number;
  enabled?: boolean;
  locale?: string;
  offset?: number;
  limit?: number;
  sort?: "title" | "createdAt" | "updatedAt";
  order?: "ASC" | "DESC";
  options?: any;
}

export default (params: VideoListParams, options?: any) => {
  return api.VideoApi.list(
    params.ids,
    params.title,
    params.ownerId,
    params.companyId,
    params.categoryId,
    params.viewerId,
    params.priceMin,
    params.priceMax,
    params.enabled,
    params.locale,
    params.offset,
    params.limit,
    params.sort,
    params.order,
    params.options
  );
};
